// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel-module--container--3MNfH","old":"Carousel-module--old--1SAHC","new":"Carousel-module--new--3g2JN"};